<script setup>
import EtablissementCreateDialog from '@/components/etablissement/etablissement-create-dialog.vue'
import SLateralPanel from '@/components/global/s-lateral-panel.vue'
import SPage from '@/components/global/s-page.vue'
</script>

<template>
  <s-page>
    <template v-slot:lateral-panel>
      <s-lateral-panel>
        <etablissement-create-dialog v-if="isInRole('Administrateur')" />
      </s-lateral-panel>
    </template>
  </s-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'etablissement',
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      isInRole: 'security/isInRole',
    }),
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
